import palette from 'theme/palette';

const MuiInputBase = {
  styleOverrides: {
    root: {
      color: palette.black,
      '& input:disabled': {
        color: palette.grey.dark,
      },
      '& textarea:disabled': {
        color: palette.grey.dark,
      },
    },
    input: {
      backgroundColor: palette.grey.light,
    },
  },
};

export default MuiInputBase;
